(() => {
  let ratingsPromise;
  const loadRatings = source => {
    if (!ratingsPromise) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 6000);
      ratingsPromise = fetch(source, { headers: { Accept: 'application/json' }, signal: controller.signal })
        .then(response => {
          if (!response.ok) throw new Error('Reviews unavailable');
          return response.json();
        }).finally(() => clearTimeout(timer));
    }
    return ratingsPromise;
  };
  const init = scope => {
    scope.querySelectorAll('[data-tt-google]').forEach(badge => {
      if (badge.dataset.ready) return;
      badge.dataset.ready = 'true';
      loadRatings(badge.dataset.reviewsSource).then(data => {
        const score = Number(data.average_rating);
        if (!Number.isFinite(score) || score < 1 || score > 5) return;
        badge.querySelector('[data-review-score]').textContent = score.toFixed(1);
        badge.querySelector('.ttp-stars').style.setProperty('--review-fill', `${score * 20}%`);
      }).catch(() => {});
    });
    scope.querySelectorAll('[data-tt-fit-link]').forEach(link => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', () => {
        const details = document.getElementById('tt-product-fit');
        if (details) details.open = true;
      });
    });
    scope.querySelectorAll('[data-tt-extras]').forEach(details => {
      if (details.dataset.ready) return;
      details.dataset.ready = 'true';
      const form = details.closest('form');
      const countLabel = details.querySelector('[data-extra-count]');
      const hint = details.querySelector('[data-extra-hint]');
      const paymentButton = form?.querySelector('.shopify-payment-button');
      const paymentInitiallyHidden = Boolean(paymentButton?.hidden);
      const update = () => {
        const inputs = Array.from(details.querySelectorAll('input[type="checkbox"]'));
        details.hidden = inputs.length === 0;
        const count = inputs.filter(input => input.checked).length;
        countLabel.hidden = count === 0;
        const label = `${count} ${countLabel.dataset.label}`;
        if (countLabel.textContent !== label) countLabel.textContent = label;
        hint.hidden = count === 0;
        if (paymentButton) paymentButton.hidden = paymentInitiallyHidden || count > 0;
      };
      details.addEventListener('change', update);
      details.addEventListener('input', update);
      const observer = new MutationObserver(update);
      observer.observe(details, { childList: true, subtree: true });
      window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
      details.addEventListener('tt-product-cleanup', () => observer.disconnect(), { once: true });
      update();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-tt-extras]').forEach(details => details.dispatchEvent(new Event('tt-product-cleanup'))));
})();
